import { useCurrentUser } from '@beholos/holoscommon';
import { Link } from 'react-router-dom';

const UserStatusCard = () => {
  const { user } = useCurrentUser();
  const { firstname, hasPlan, isCorporate } = user || {};
  const { levelName = '', levelImage, fitPoints, points, accepted, progressWidth } = user?.rewards || {};

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-4">
        <img
          src="https://image.beholos.com/img/holos/general/ic-default-profile.webp"
          alt="Profile"
          className="w-[70px] mt-2 rounded-full"
        />
        <div>
          <h3 className="text-4xl font-medium font-juana">Hola, {firstname}</h3>
          {hasPlan === true && isCorporate && (
            <a
              href="/user/mi-membresia/administrar"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-1 inline-block text-xs text-white bg-black px-6 py-2 rounded-xl"
            >
              Mejorar mi plan
            </a>
          )}
        </div>
      </div>

      <div className="flex justify-end sm:justify-start border-b border-t border-gray-300 py-4">
        <div className="flex w-full items-start gap-3 align-center">
          {levelImage && (
            <div className="w-10 h-10 flex items-center align-center">
              <img src={levelImage} alt={levelName || ''} className="w-full h-full object-contain" />
            </div>
          )}
          <div className="w-full">
            {accepted ? (
              <>
                <div className="text-md font-medium">Nivel: {levelName}</div>
                <div className="text-md font-light text-gray-600">
                  {fitPoints?.toLocaleString()} HoloPoints
                </div>
                <p className="text-gray-400 text-sm font-light">
                  {points?.toLocaleString()} Experience Points
                </p>
                <div className="w-full h-2 bg-gray-200 rounded mt-2">
                  <div
                    className="h-full rounded bg-holos-dark"
                    style={{ width: `${progressWidth || 0}%` }}
                  />
                </div>
              </>
            ) : (
              <Link
                to="/mis-logros"
                className="text-xs text-black border border-black px-2 py-1 rounded"
              >
                Empezar a ganar puntos
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserStatusCard;
